import styled from "styled-components";
import { FiBell } from "react-icons/fi";

export const NewsletterContainer = styled.div`
  background-color: #2b2e46;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
  margin-top: -50px;

  @media screen and (max-width: 456px) {
    padding-bottom: 85px;
    margin-top: 0;
  }
  @media screen and (max-width: 456px) {
    padding-bottom: 70px;
    margin-top: 0;
  }
`;
export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1008px) {
    flex-direction: column;
  }
`;

export const NewsletterInput = styled.input`
  width: 600px;
  border-radius: 5px;
  border: none;
  background-color: #1b1b1b;
  color: #ffb400;
  font-size: 1.5rem;
  padding: 1rem 4rem;

  @media screen and (max-width: 1008px) {
    margin-bottom: 1.5rem;
  }

  @media screen and (max-width: 856px) {
    width: 80vw;
    font-size: 1.2rem;
  }

  @media screen and (max-width: 550px) {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`;
export const NewsletterButton = styled.button`
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-size: 1.5rem;
  font-weight: bold;
  padding: 1rem 2rem;

  border-radius: 5px;
  background-color: #96a9fe;
  white-space: nowrap;

  color: #fefefa;

  outline: none;
  border: none;
  cursor: pointer;

  transition: all 0.2s ease-in-out;
  text-decoration: none;

  @media screen and (max-width: 1008px) {
    font-size: 1.2rem;
    margin-bottom: 16px;
  }

  @media screen and (max-width: 756px) {
    font-size: 1rem;
  }

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: #ffb400;
  }
`;

export const BellIcon = styled(FiBell)`
  margin-right: 5px;
`;
